import { DateRangePicker, Datepicker } from 'flowbite-datepicker';
import ru from 'vanillajs-datepicker/locales/ru';

document.addEventListener('DOMContentLoaded', () => {
  const datepickerEl = document.getElementById('datepickerId');
  if (datepickerEl) {
    Datepicker.locales.ru = ru.ru
    new DateRangePicker(datepickerEl, {
      language: 'ru',
      format: 'dd.mm.yyyy',
    });
  }
});